import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { usePushSubscription } from 'server';
import { useAppSelector } from 'js/store/hooks';
import { setDetails } from 'js/hooks/user/store/actions';

export const useOnAgeVerificationStatusChange = () => {
    const dispatch = useDispatch();
    const enableDataVerificationStatusCheck = useAppSelector(prop('enableDataVerificationStatusCheck'));

    usePushSubscription(31133, () => (pushMessage: any) => {
        const { playerData: { ageVerificationStatus = '' } = {} } = pushMessage?.data?.action?.actionPlayerInfoChangeInfo || {};

        if (enableDataVerificationStatusCheck && ageVerificationStatus) {
            dispatch(setDetails({ ageVerificationStatus }));
        }
    }, [enableDataVerificationStatusCheck, dispatch]);
};
